import { Component, OnInit } from '@angular/core';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';
import { SharedService } from '@AppRoot/shared/services/shared.service';

interface Faq {
  id: number;
  question: string;
  answer: string;
  category?: string;
  isOpen: boolean;
}

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
})
export class FaqsComponent implements OnInit {
  faqs: Faq[] = [];
  filteredFaqs: Faq[] = [];
  categories: string[] = [];
  selectedCategory: string | null = null;
  searchQuery: string = '';

  constructor(private sharedService: SharedService) {}

  ngOnInit(): void {
    this.fetchFaqs();
  }

  private fetchFaqs(): void {
    this.sharedService.getFaq().subscribe({
      next: (response: APIResponse) => {
        const faq = response.data || [];
        this.faqs = faq.map((faq: any) => ({
          ...faq,
          isOpen: false,
        }));

        this.filteredFaqs = [...this.faqs];
        this.extractCategories();
      },
      error: () => {},
    });
  }

  toggleFaq(index: number): void {
    this.filteredFaqs[index].isOpen = !this.filteredFaqs[index].isOpen;
  }

  filterFaqs(): void {
    if (!this.searchQuery.trim()) {
      this.applyFilters();
      return;
    }

    const query = this.searchQuery.toLowerCase();

    this.filteredFaqs = this.faqs.filter((faq) => {
      const matchesQuery =
        faq.question.toLowerCase().includes(query) ||
        faq.answer.toLowerCase().includes(query);

      const matchesCategory =
        !this.selectedCategory || faq.category === this.selectedCategory;

      return matchesQuery && matchesCategory;
    });
  }

  filterByCategory(category: string | null): void {
    this.selectedCategory = category;
    this.applyFilters();
  }

  resetFilters(): void {
    this.searchQuery = '';
    this.selectedCategory = null;
    this.filteredFaqs = [...this.faqs];
  }

  private applyFilters(): void {
    let filtered = [...this.faqs];

    if (this.selectedCategory) {
      filtered = filtered.filter(
        (faq) => faq.category === this.selectedCategory
      );
    }

    if (this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter(
        (faq) =>
          faq.question.toLowerCase().includes(query) ||
          faq.answer.toLowerCase().includes(query)
      );
    }

    this.filteredFaqs = filtered;
  }

  private extractCategories(): void {
    const categorySet = new Set<string>();
    this.faqs.forEach((faq) => {
      if (faq.category) {
        categorySet.add(faq.category);
      }
    });
    this.categories = Array.from(categorySet);
  }
}
